import React, { useState } from "react";
import './WebDesign.css';
import digitalexperience from './assets/digitalexperience.jpg';
import professionalmatters from './assets/professionalmatters.jpg';

const WebDeveloping = () => {
    return (
        <>
            {/* Banner Section */}
            <section className="webdesign-section">
                <div className="webdesign-overlay">
                    <div className="webdesign-content">
                        <h1 className="webdesign-title">Web Developing</h1>
                        <p className="webdesign-breadcrumb">
                            <span>Dot LocalHost</span> &gt; <span>Web Developing</span>
                        </p>
                    </div>
                </div>
            </section>

            {/* second Section */}
            <div className="company-section py-5">
                <div className="container">
                    <div className="row align-items-center">
                        {/* Left Text Column */}
                        <div className="col-md-6 text-column">
                            <h2>Web Development Building the Digital Experience</h2>                            
                            <p>Your website is the digital face of your business, and it needs to make a lasting impression. At Dot Localhost, we specialize in creating visually stunning and highly functional websites that not only look great but also deliver outstanding user experiences. Whether it’s a sleek, professional portfolio or a full-fledged e-commerce platform, we build websites that captivate visitors and drive results.</p>
                            <p>We combine industry-leading design with responsive technology to ensure your site performs seamlessly across all devices.</p>

                            <h3>What We Offer</h3>
                            <ul>
                                <li><b>Custom Website Design and Development:</b> We create bespoke websites tailored to your brand identity and business goals.</li>
                                <li><b>E-Commerce Development:</b> Our solutions help you sell online with secure payment gateways and a seamless shopping experience.</li>
                                <li><b>CMS Solutions:</b> Manage your website content effortlessly with our user-friendly content management systems.</li>
                                <li><b>Full Mobile Optimization:</b> Your website will function smoothly on smartphones, tablets, and desktops alike.</li>                               
                            </ul>
                        </div>

                        {/* Right Image Column */}
                        <div className="col-md-6">
                            <img src={digitalexperience} alt="About Us" className="img-fluid about-image" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 side-images py-5">
                            <img src={professionalmatters} alt="Mobile Optimization" className="mt-3" />
                        </div>
                        <div className="col-md-6 py-5">
                            <div className="content-section">
                                <h2>Why a Professional Website Matters</h2>
                                <p>Your website is often the first interaction potential customers have with your brand. A well-designed, high-performing site can:</p>
                                <ul>
                                    <li>Increase credibility and brand trust.</li>
                                    <li>Improve customer engagement and retention.</li>
                                    <li>Enhance user experience and ease of navigation.</li>
                                    <li>Boost sales conversions and lead generation.</li>
                                    <li>Improve search engine rankings through optimized performance.</li>
                                    <li>Provide seamless access across multiple devices.</li>
                                </ul>
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
        </>
    );
};

export default WebDeveloping;